@let isMobile = isMobile$ | async;

@defer (when (isMobile)) {
  @if (isMobile) {
    <div class="hotels-home" [class.showInput]="showInput">
      @if (!isByHours) {
        <app-hotel-search
          [source]="source"
          [isMobile]="isMobile"
          [loadDefaultplaces]="loadDefaultplaces"
          (showRoomsComponent)="showRoomsEdition()"
          (showDestination)="showDestination($event)"
          (showMobileCalendarEvent)="showMobileCalendar($event)">
        </app-hotel-search>
      } @else {
        <app-byhours-search
          [source]="source"
          [isMobile]="isMobile"
          [loadDefaultplaces]="loadDefaultplaces"
          (showDestination)="showDestination($event)"
          (showMobileCalendarEvent)="showMobileCalendar($event)">
        </app-byhours-search>
      }
    </div>
  }
}

<router-outlet name="search"></router-outlet>
